module.exports = __webpack_public_path__ + "static/media/importICloud3.520421ea.png";